
$(document).on('ready', function () {
	$(".full-screen").slick({
		centerMode: true,
		arrows: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 1000,
		infinite: true,
		slidesToShow: 3,
		centerPadding: '100px',
		lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1181, // 1180px以下のサイズに適用
				settings: {
					slidesToShow: 2,
					centerPadding: '50px',
				},
			},
			{
				breakpoint: 768, // 767px以下のサイズに適用
				settings: {
					slidesToShow: 1,
					centerPadding: '0px',
				},
			},
		],

	});
});

function match_height(target_attr) {
	const target_elements = document.querySelectorAll(target_attr);

	if (target_elements.length > 1) {
		let height_array = [];
		target_elements.forEach((element) => {
			const height = element.clientHeight;
			height_array.push(height);
		});
		const max_height = Math.max(...height_array);

		target_elements.forEach((node) => {
			node.style.height = max_height + 'px';
		});
	}
}
$(window).on('load', function () {
	match_height('.sliderArea .article-desc .article-ttl');
	match_height('.sliderArea .article-desc');
	//match_height('.sliderArea .article-desc .tags');
});
